import React, { lazy } from 'react';

const Dialogs = lazy(() => import('pages/Dialogs/Dialogs'));
const Profile = lazy(() => import('pages/Profile/Profile'));
const Settings = lazy(() => import('pages/Settings/Settings'));
const Gallery = lazy(() => import('pages/Gallery/Gallery'));
const Chat = lazy(() => import('pages/Chat/Chat'));
const Registration = lazy(() => import('pages/Registration/Registration'));
const BlockList = lazy(() => import('pages/BlockList/BlockList'));
const Hobbies = lazy(() => import('pages/Hobbies/Hobbies'));
const Selection = lazy(() => import('pages/Selection/Selection'));
const Compatibility = lazy(() => import('pages/Compatibility/Compatibility'));
const Tests = lazy(() => import('pages/PersonalityTests/PersonalityTests'));
const Questionnaire = lazy(() => import('pages/Questionnaire/Questionnaire'));

export enum PrivatePath {
    dialogs = '/dialogs',
    profile = '/profile',
    settings = '/settings',
    gallery = '/gallery',
    chat = '/chat/:uuid',
    registration = '/registration',
    support = '/chat/0',
    blocklist = '/blocklist',
    hobbies = '/hobbies',
    selection = '/hobbies/:hobbyId',
    compatibility = '/compatibility/:uuid',
    tests = '/tests',
    questionnaire = '/tests/:id',
}

export const privateRoutes = [
    {
        path: PrivatePath.dialogs,
        page: <Dialogs />,
    },
    {
        path: PrivatePath.profile,
        page: <Profile />,
    },
    {
        path: PrivatePath.settings,
        page: <Settings />,
    },
    {
        path: PrivatePath.gallery,
        page: <Gallery />,
    },
    {
        path: PrivatePath.chat,
        page: <Chat />,
    },
    {
        path: PrivatePath.registration,
        page: <Registration />,
    },
    {
        path: PrivatePath.blocklist,
        page: <BlockList />,
    },
    {
        path: PrivatePath.hobbies,
        page: <Hobbies />,
    },
    {
        path: PrivatePath.selection,
        page: <Selection />,
    },
    {
        path: PrivatePath.compatibility,
        page: <Compatibility />,
    },
    {
        path: PrivatePath.tests,
        page: <Tests />,
    },
    {
        path: PrivatePath.questionnaire,
        page: <Questionnaire />,
    },
];
